import { useState, useEffect } from 'react';
import { useResolveProductImage } from './product-image-context';

export function useOfferImage(imageUrl: string | undefined, productId: string | undefined): string | null {
  const resolveProductImage = useResolveProductImage();
  const [resolved, setResolved] = useState<string | null>(imageUrl || null);

  useEffect(() => {
    if (imageUrl) {
      setResolved(imageUrl);
      return;
    }

    setResolved(null);
    if (!productId) return;

    let cancelled = false;

    if (resolveProductImage) {
      void resolveProductImage(productId).then((url) => {
        if (!cancelled && url) setResolved(url);
      });
      return () => {
        cancelled = true;
      };
    }

    return () => {
      cancelled = true;
    };
  }, [imageUrl, productId, resolveProductImage]);

  return resolved;
}
